import React, { useState } from "react";
import styles from "./AdminEventLog.module.css";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import {
  DateInput,
  Dropdown,
  InputField,
  SubmitButton,
} from "../../../../components";
import { Table } from "antd";
import { LuSearch } from "react-icons/lu";
const AdminEventLog = () => {
  const columns = [
    {
      title: "Date & Time",
      dataIndex: "DateTime",
      key: "Date & Time",
    },
    {
      title: "User",
      dataIndex: "User",
      key: "User ",
    },
    {
      title: "User Type",
      key: "UserType",
      dataIndex: "UserType",
    },
    {
      title: "Action Type",
      key: "ActionType",
      dataIndex: "ActionType",
    },
    {
      title: "Description",
      key: "Description",
      dataIndex: "Description",
    },
  ];

  const data = [
    {
      DateTime: "2025-09-11 10:23 AM",
      User: "John Smith ",
      UserType: "Supervisor",
      ActionType: "Order Update",
      Description: "Order 2203 marked as Completed",
    },
    {
      DateTime: "2025-09-11 10:23 AM",
      User: "Sarah Jones ",
      UserType: "Admin",
      ActionType: "Inventory",
      Description: "Flour Lot A-102 reduced by 5kg",
    },
    {
      DateTime: "2025-09-11 10:23 PM",
      User: "David Smith ",
      UserType: "Admin",
      ActionType: "Inventory",
      Description: "Muffins recipe (sugar increased)",
    },
  ];

  const [searchUser, setSearchUser] = useState("");
  const [Date, setDate] = useState("");
  const [ActionType, setActionType] = useState({
    value: "Order Update	",
    role: "Order Update	",
    id: 1,
  });

  const DropDownOptions = [
    {
      value: "Order Update	",
      role: "Order Update	",
      id: 1,
    },
    {
      value: "Inventory",
      role: "Inventory",
      id: 2,
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"Events Logs"} showBackIcon={false} />
      <div className={styles.subCont}>
        <div className={styles.ActionDiv}>
          <div className={styles.ButtonDiv}>
            <DateInput
              label={"From"}
              placeholder={"6/4/2025"}
              rightIcon={<LuSearch />}
              value={Date}
              onChange={setDate}
            />
              <DateInput
              label={"To"}
              placeholder={"6/4/2025"}
              rightIcon={<LuSearch />}
              value={Date}
              onChange={setDate}
            />
            <InputField
              label={"User"}
              value={searchUser}
              onChange={(e) => setSearchUser(e.target.value)}
              placeholder={"Search User.."}
              rightIcon={<LuSearch />}
            />
            <Dropdown
              label={"Action Type"}
              placeholder={"Select Action"}
              value={ActionType}
              options={DropDownOptions}
              onChange={(e) => setActionType(e)}
            />
            <SubmitButton title={"Apply Filters"} primary />
          </div>
          <InputField
            placeholder={"search"}
            rightIcon={<LuSearch />}
          />
        </div>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminEventLog;
